import Phaser from "phaser";

export class BootScene extends Phaser.Scene {
  constructor() {
    super("BootScene");
  }

  preload(): void {
    const label = document.querySelector<HTMLElement>("#loading-message");
    const bar = document.querySelector<HTMLElement>("#loading-progress");

    this.load.on("progress", (value: number) => {
      if (bar) bar.style.width = `${Math.round(value * 100)}%`;
      if (label) label.textContent = `กำลังเตรียมฟาร์ม ${Math.round(value * 100)}%`;
    });

    this.load.image("farm-background", "/assets/game/farm-background-v1.png");

    const productionSprites = [
      "env-house", "env-shop", "env-plot", "env-pond", "env-apple-tree", "env-fence",
      "env-flowers", "env-stepping-stones", "env-cat-house", "env-watering-can",
      "env-birdhouse", "env-bridge",
      "cat-mali-idle", "cat-mali-walk-a", "cat-mali-walk-b", "cat-mali-happy",
      "cat-khram-idle", "cat-khram-walk-a", "cat-khram-walk-b", "cat-khram-happy",
      "cat-fai-idle", "cat-fai-walk-a", "cat-fai-walk-b", "cat-fai-happy",
      "crop-carrot-seed", "crop-carrot-sprout", "crop-carrot-growing", "crop-carrot-ready",
      "crop-tomato-seed", "crop-tomato-sprout", "crop-tomato-growing", "crop-tomato-ready",
      "crop-cabbage-seed", "crop-cabbage-sprout", "crop-cabbage-growing", "crop-cabbage-ready",
      "ui-carrot", "ui-tomato", "ui-cabbage", "ui-seed-packet", "ui-bag", "ui-cat",
      "ui-shop", "ui-decor", "ui-water", "ui-food", "ui-coin", "ui-close",
    ];

    for (const key of productionSprites) {
      this.load.image(key, `/assets/game/webp/${key}.webp`);
    }

    const animationFrames = [
      "player-idle-a", "player-idle-b", "player-walk-a", "player-walk-b",
      "player-walk-c", "player-walk-d", "player-plant", "player-water",
      "player-harvest", "player-feed", "player-pet", "player-happy",
      "cat-mali-sit", "cat-mali-eat", "cat-mali-pet", "cat-mali-sleep-v2",
      "cat-khram-sit", "cat-khram-eat", "cat-khram-pet", "cat-khram-sleep-v2",
      "cat-fai-sit", "cat-fai-eat", "cat-fai-pet", "cat-fai-sleep-v2",
    ];
    for (const key of animationFrames) {
      this.load.image(key, `/assets/game/web/${key}.png`);
    }

    this.load.image("cat-fai-sleep", "/assets/game/web/cat-fai-sleep.png");
    this.load.image("cat-khram-crouch", "/assets/game/web/cat-khram-crouch.png");
    this.load.image("env-duck", "/assets/game/web/env-duck.png");
  }

  create(): void {
    const label = document.querySelector<HTMLElement>("#loading-message");
    if (label) label.textContent = "พร้อมแล้ว กำลังเปิด Cat Town";
    this.scene.start("FarmScene");
  }
}
